'use strict'

function assert(x, msg) {
  if (!x) throw new Error(msg || 'Assertion failed')
}

function assertEmptyRest(rest) {
  if (Object.keys(rest).length !== 0) throw new TypeError('Unexpected extra options')
}

const makeMessage = (name, extra) => `Expected${name ? ` ${name} to be` : ''} an Uint8Array${extra}`

function assertUint8AnySize(arr, name) {
  asUint8AnySize(arr, name) // asserts
}

function asUint8AnySize(arr, name) {
  if (arr instanceof Uint8Array) return arr
  throw new TypeError(makeMessage(name, ''))
}

function assertUint8(arr, size, name) {
  asUint8(arr, size, name) // asserts
}

function asUint8(arr, size, name) {
  if (arr instanceof Uint8Array && arr.length === size) return arr
  throw new TypeError(makeMessage(name, ` of size ${Number(size)}`))
}

function assertUint8orString(input, name) {
  asUint8orString(input, name) // asserts
}

function asUint8orString(input, name) {
  if (typeof input === 'string' || input instanceof Uint8Array) return input
  throw new TypeError(makeMessage(name, ' or a string'))
}

function assertInteger(x, name, min) {
  if (Number.isSafeInteger(x) && x >= min) return
  throw new TypeError(`Expected ${name} to be a safe integer >= ${Number(min)}`)
}

module.exports = {
  assert,
  assertEmptyRest,
  assertUint8AnySize,
  assertUint8,
  asUint8AnySize,
  asUint8,
  assertUint8orString,
  asUint8orString,
  assertInteger,
}
